const desires = [
  'Tu comprends exactement comment fonctionne la Bourse et tu te sens confiant(e)',
  'Tu génères des revenus passifs chaque mois grâce à tes investissements',
  'Tu sais choisir les bonnes actions sans stress ni incertitude',
  'Tu construis un patrimoine solide qui travaille pour toi pendant que tu profites de ta vie',
];

const ImagineSection = () => (
  <section className="bg-white py-14 px-8 lg:px-16">
    <div className="max-w-[860px] mx-auto">
      <h2 className="text-[#1E0750] font-black text-3xl lg:text-4xl text-center mb-8">
        Imagine-toi plutôt...
      </h2>
      <div className="flex flex-col gap-4">
        {desires.map((d, i) => (
          <div key={i} className="flex items-start gap-4 bg-[#F0FFF0] border border-[#A3E635]/40 rounded-xl p-5">
            <div className="w-7 h-7 flex items-center justify-center bg-[#A3E635] rounded-full flex-shrink-0 mt-0.5">
              <i className="ri-check-line text-[#1E0750] text-sm font-bold" />
            </div>
            <p className="text-[#1E0750] font-semibold text-sm leading-relaxed">{d}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default ImagineSection;
